import React, { useState } from 'react';
import { useMutation } from 'react-apollo';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

import { accountUpdate as accountUpdateMutation } from '../../../graphql/mutations/account';
import AssetUpload from '../../../apps/pro/views/Album/AlbumSlideshow/AlbumSlideshowDesignerView/components/PhotoSelectionOverlayModal/components/AssetUpload';
import Button from '../../../components/global/Button';
import useAccount from '../../../components/global/hooks/useAccount';

const AssetImageUpload = () => {
  const location = useLocation();
  const { existingAssetImageId } = qs.parse(location.search);
  const [assetImage, setAssetImage] = useState(null);
  const [accountUpdate] = useMutation(accountUpdateMutation);
  const { account } = useAccount();

  const existingAssetImageIdBool = ['1', 'true'].includes(existingAssetImageId);

  if (assetImage) {
    return (
      <div className="text-center p-4">
        <h3>Success!</h3>
        <img src={assetImage.url} alt="FAILED" style={{ width: '50%' }} />
        <p>
          Your asset image id is <b>{assetImage.id}</b>
        </p>
        <Button className="mt-2" onClick={() => setAssetImage(null)}>
          Upload another one
        </Button>
      </div>
    );
  }
  return (
    <div className="text-center p-4">
      <AssetUpload
        onUploaded={async asset => {
          if (existingAssetImageIdBool) {
            const {
              data: {
                accountUpdate: { account: updatedAccount },
              },
            } = await accountUpdate({
              variables: {
                input: {
                  id: account.id,
                  logo_image: {
                    asset_image_id: asset.id,
                  },
                },
              },
            });
            setAssetImage(updatedAccount.logo_image);
          } else {
            setAssetImage(asset);
          }
        }}
      />
    </div>
  );
};

export default AssetImageUpload;
